export const ErrorMonitoringDependencyTypes = {
  // Keep the web-common token so existing consumers and test helpers share the binding,
  // without importing its SDK-backed runtime entry point during bootstrap.
  ErrorMonitoringService: Symbol.for('ErrorMonitoringService'),
};
